import { PasseriniAPI } from './apiService';
import { Usuario } from '@/auth/types';
import { LoginFormData, ApiResponse } from '../types';

interface LoginParams {
  email: string;
  password: string;
}

interface LoginResponse {
  success: boolean;
  data: {
    user: Usuario;
    token: string;
  };
}

interface TokenParams {
  token: string;
}

interface CreateUserParams {
  user: Partial<Usuario> & {
    password: string;
    password_confirmation: string;
  };
}

interface ChangePasswordParams {
  user: {
    current_password: string;
    password: string;
    password_confirmation: string;
  };
}

interface NotifyCredentialsParams {
  email: string;
}

export const login = ({ email, password }: LoginParams) => {
  return PasseriniAPI.post('/login', { email, password });
};

export const getUser = ({ token }: TokenParams) => {
  return PasseriniAPI.get<{ user: Usuario }>('/user', {
    headers: {
      'Authorization': `Bearer ${token}`
    },
  });
};

export const logout = ({ token }: TokenParams) => {
  return PasseriniAPI.post('/logout', undefined, {
    headers: {
      'Authorization': `Bearer ${token}`
    },
  });
};

export const createUser = async ({ user }: CreateUserParams): Promise<any> => {
  const response = await PasseriniAPI.post('/register', user);
  return response.data;
};

export const changePassword = async ({ user }: ChangePasswordParams): Promise<any> => {
  const response = await PasseriniAPI.patch('/change-password', user);
  return response.data;
};

export const notifyCredentials = async (data: NotifyCredentialsParams): Promise<any> => {
  const response = await PasseriniAPI.post('/notify/credentials', data);
  return response.data;
};
